import { createCachedLearningAudio } from '@shared/media/audio/learning-audio-cache'
import { useWarmLearningAudio } from '@shared/media/audio/use-warm-learning-audio'

export type LearningFeedbackResult = 'correct' | 'incorrect'

const FEEDBACK_AUDIO_SOURCES: Record<LearningFeedbackResult, string> = {
  correct: '/audios/right.mp3',
  incorrect: '/audios/wrong.mp3',
}

export function useWarmLearningFeedbackAudio() {
  useWarmLearningAudio(Object.values(FEEDBACK_AUDIO_SOURCES))
}

/**
 * Play a short result cue from a learner action. The caller deliberately
 * ignores a rejected promise because browsers may still block sound when the
 * action is no longer considered user initiated.
 */
export function playLearningFeedbackAudio(result: LearningFeedbackResult) {
  if (typeof Audio === 'undefined') {
    return
  }

  const audio = createCachedLearningAudio(FEEDBACK_AUDIO_SOURCES[result])
  void audio.play().catch(() => undefined)
}
